// Generated file - do not change manually!

/**
 * Types for the placement of Popover control.
 */
export enum PopoverPlacementType {
  /**
   * Popover will be placed at the bottom of the reference element.
   */
  Bottom = 'Bottom',

  /**
   * Popover will be placed at the left side of the reference element.
   */
  Left = 'Left',

  /**
   * Popover will be placed at the right side of the reference element.
   */
  Right = 'Right',

  /**
   * Popover will be placed at the top of the reference element.
   */
  Top = 'Top'
}
